const getWWWUrl = (url) => {
  if (!url) return "";

  let protocol = "";

  if (/^https?:\/\//i.test(url)) {
    protocol = url.match(/^https?:\/\//i)[0];
    url = url.replace(protocol, "");
  }

  // 已经有 www
  if (url.startsWith("www.")) {
    return protocol + url;
  }

  const parts = url.split(".");

  // 判断是否是已有子域名
  // 例如：
  // uk.example.com
  // ca.example.com
  // sg.example.com
  const commonSubDomains = ["uk", "us", "ca", "sg", "jp", "de", "fr", "au"];

  if (commonSubDomains.includes(parts[0])) {
    return protocol + url;
  }

  // 其他情况统一加 www
  return protocol + `www.${url}`;
};

export default getWWWUrl;
